import React from 'react';
import 'react-loading-skeleton/dist/skeleton.css';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';

const SkeletonListing = ({ columnCount, rowCount }) => {
  // Generate rows of Skeleton components
  let rows = [];

  for (let rowIndex = 0; rowIndex < rowCount; rowIndex++) {
    let columns = [];
    for (let index = 0; index < columnCount; index++) {
      columns.push(<Skeleton count={1} key={index} height={20} />);
    }
    // Push each row into the rows array
    rows.push(
      <tr key={rowIndex} className="mb-4">
        <td colSpan={columnCount}>
          <SkeletonTheme baseColor="#ECECEC" highlightColor="#ffffff">
            <div
              className={'p-4 grid gap-4 w-full bg-gray-50 rounded-xl'}
              style={{
                gridTemplateColumns: `repeat(${columnCount}, 1fr)`,
              }}
            >
              {columns}
            </div>
          </SkeletonTheme>
        </td>
      </tr>,
    );
  }

  return <tbody>{rows}</tbody>;
};

export default SkeletonListing;
